import { Quiz, QuizQuestion } from './types';

export const CHRNCL_SOCIAL = [
  { icon: 'mdi-twitter', link: 'https://twitter.com/getchrncl' },
  { icon: 'mdi-instagram', link: 'https://www.instagram.com/getchrncl/' },
];

export const ENABLED_FEATURES = {};
export const BRAND_NAME = 'Bhang';
export const BRAND_DESC = 'Bhang is a cannabis pioneer with a passion for crafting high-quality, natural products. Built on a tradition of innovation and driven by our pursuit of bold flavors, we help people around the world to shape their own experiences and live life with a Bhang!';


export const BRAND_COLOR = '#dd6806';
export const BRAND_SOCIAL = [
  { icon: 'mdi-facebook', link: '' },
  { icon: 'mdi-twitter', link: '' },
  { icon: 'mdi-instagram', link: '' },
  { icon: 'mdi-youtube', link: '' },
];
export const HOME_SLIDER = [
  {
    img: require('@/assets/bhang_art.jpg'),
    title: 'WATCH',
    page: '/broadcast',
    id: '',
  },
  {
    img: require('@/assets/bhang_art_3.jpg'),
    title: 'MEET',
    page: '/learn',
    id: '',
  },
  {
    img: require('@/assets/bhang_product-3.jpg'),
    title: 'CONNECT',
    page: '/budtenders',
    id: '',
  },
];

export const BRAND_CENTER_DESC = 'Home to all of our logos, product shots, and art available to download.';

export const LEARN_ABOUT_DESC = 'Bhang is a cannabis pioneer with a passion for crafting high-quality, natural products. Built on a tradition of innovation and driven by our pursuit of bold flavors, we help people around the world to shape their own experiences and live life with a Bhang!';

// Budtender Experience

const BRAND_QUESTIONS: Array<QuizQuestion> = [
  {
    answers: [
      'Three states (CA, NM, IL)',
      'Two countries (US and CAN)',
      'CBD can ship anywhere in US',
      'Two states (CA, CO)',
    ],
    type: 'MultipleChoice',
    answer: 'Three states (CA, NM, IL)',
    correctText:
      'Bhang is currently in CA, NM, and IL, but is planning to expand to others soon!',
    wrongText:
      'Bhang is currently in CA, NM, and IL, but is planning to expand to others soon!',
    question: 'How many states is Bhang sold in?',
  },
  {
    answers: ['Roasted cacao seeds', 'Sugar', 'Milk', 'Cannabis!'],
    answer: 'Cannabis!',
    type: 'MultipleChoice',

    correctText:
      'We use top-shelf cannabis, as well as organic cacao, sugar and milk.',
    wrongText:
      'While we use all organic and fresh ingredients, we pride ourselves in using top-shelf cannabis!',
    question: 'What is the most important ingredient in Chocolate?',
  },
  {
    answers: [
      'Milk Chocolate and Chill',
      'Fire and ice',
      'Blackberry Smoothie',
      'Dark Chocolate',
    ],
    type: 'MultipleChoice',
    answer: 'Milk Chocolate and Chill',
    correctText:
      'Our most popular product is the milk chocolate bar.',
    wrongText:
      'While that is popular, our best seller is the Milk Chocolate variation of the chocolate bar.',
    question: 'What’s the most popular product of Bhang?',
  },
  {
    answers: ['Roasted cacao seeds', 'Sugar', 'Milk', 'Cannabis!'],
    answer: 'Cannabis!',
    type: 'MultipleChoice',
    correctText:
      'We use top-shelf cannabis, as well as organic cacao, sugar and milk.',
    wrongText:
      'While we use all organic and fresh ingredients, we pride ourselves in using top-shelf cannabis!',
    question: 'What is the most important ingredient in Chocolate?',
  },
];
const BRAND: Quiz = {
  title: 'Brand Quiz',
  questions: BRAND_QUESTIONS,
};

export const QUIZZES = {
  BRAND,
};
